import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {Provider} from "react-redux";
import store from "./store";
import { RouterProvider } from 'react-router-dom';
import {router} from "./routes/router";
import { ChakraProvider } from '@chakra-ui/react'
import theme from './common/chakraCustomTheme'

const root = ReactDOM.createRoot(
  document.getElementById('kfa') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>
);
